import { useLoadedUser } from './api/useUser';

export default function useIsTestUser(): boolean {
    const { user } = useLoadedUser({});
    return user?.isTestUser || false;
}
